import React from 'react';
import { Link } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';

const NotFound = ({ description, backTo }) => {
    const backToLink = backTo ? <Link to={backTo}>Voltar</Link> : null;

    return (
        <div className="container mt-5 mb-5 p-5 d-flex flex-column justify-content-center align-items-center">
            <div className="d-flex justify-content-center align-items-center">
                <div><FiSearch size={80} /></div>

                <div className="ml-3">
                    <h1 className="m-0">404! :/</h1>
                    <p>{ description }</p>
                </div>
            </div>

            <div className="mt-5 text-center">
                { backToLink } <br />
                <Link to="/">Ir para a página inicial</Link>
            </div>
        </div>
    );

}

export default NotFound;
